import React, { useEffect } from 'react'
import { Drawer, Card, Button, Form, Row, Col, notification } from 'antd'
import { formItemLayout,chooseEmailModalFxn } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { WithdrawalAbstractFxn } from './actions'
import moment from 'moment'

const WithdrawalAbstractDrawer = (props) => {
  let {
    form: { getFieldDecorator, setFieldsValue },
    visible,
    onClose,
    abstract
  } = props
  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      setFieldsValue({
        withdrawnDate: moment()
      })
    }, 1000)
  }, [])

  const inputSchema = {
    fields: [
      {
        label: 'Withdrawal Date',
        key: 'withdrawnDate',
        required: true,
        type: 'date'
      },
      {
        label: 'Withdrawal Note',
        key: 'withdrawalReason',
        required: true,
        span: 24,
        type: 'textarea'
      }
    ]
  }

  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll(async (err, valData) => {
      if (err) {
        notification.error({ message: 'Required', description: 'Fill all required fields.' });
        return;
      }

      chooseEmailModalFxn({
        callback: async (email) => {
          let obj = {
            fromEmail: email,
            abstractId: abstract._id,
            status: 'Withdrawn',
            withdrawnDate: valData.withdrawnDate,
            withdrawalReason: valData.withdrawalReason
          };


          let resp = await dispatch(WithdrawalAbstractFxn(obj));

          if (resp && resp.success) {
            notification.success({ message: 'Abstract Withdrawn Successfully' });

            dispatch({ type: 'START_LOAD_ABSTRACT' });

            onClose();
          } else {
            notification.error({
              message: 'Withdrawal Failed',
              description: resp.message || 'Please try again.'
            });
          }
        }
      });
    });
  };

  return (
    <Drawer
      title={`Withdraw Abstract | ID: ${abstract.onlineAbstractId}`}
      width={'40%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span ? item.span : 12} key={key}>
                <GetEachFormFields getFieldDecorator={getFieldDecorator}
                                   item={item} formItemLayout={formItemLayout} />
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

const WrappedForm = Form.create()(WithdrawalAbstractDrawer)
export default WrappedForm
